import { render, staticRenderFns } from "./Sadmin.vue?vue&type=template&id=284204af&scoped=true&"
import script from "./Sadmin.vue?vue&type=script&lang=js&"
export * from "./Sadmin.vue?vue&type=script&lang=js&"
import style0 from "./Sadmin.vue?vue&type=style&index=0&id=284204af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284204af",
  null
  
)

export default component.exports